import { pathOr } from 'ramda';

import { Box, HStack, Text, VStack } from '@frontend/components';

import HighlightOrDisplay from './HighlightOrDisplay';
import LabelText from './LabelText';
import PartCell from './PartCell';
import ValueText from './ValueText';

const OrderItemMatchCell = ({ orderItemResult }) => {
  const filename = pathOr(null, ['data', 'filenames', 0], orderItemResult);
  const primaryFileUuid = pathOr(
    null,
    ['data', 'primaryFileUuid'],
    orderItemResult,
  );
  const href = `/orders/edit/${orderItemResult.data.orderNumber}?quote_item=${orderItemResult.data.quoteItemId}`;
  return (
    <Box alignContent="left">
      <Text fontFamily="data" fontSize="sm" whiteSpace="nowrap">
        From{' '}
        <Text as="span" fontSize="sm" fontWeight="heavy">{` Order #`}</Text>
        <HighlightOrDisplay
          field="orderNumber"
          result={orderItemResult}
          textProps={{ fontWeight: 'heavy' }}
          useDataFont
        />
      </Text>
      <PartCell
        href={href}
        partResult={orderItemResult}
        filename={filename}
        primaryFileUuid={primaryFileUuid}
      />
      <HStack paddingTop={1}>
        <VStack alignItems="start" spacing={0}>
          <LabelText>Process</LabelText>
          <LabelText>Material</LabelText>
          <LabelText>Finish</LabelText>
          <LabelText>Total Price</LabelText>
          <LabelText>Unit Price</LabelText>
          <LabelText>Quantity</LabelText>
        </VStack>
        <VStack alignItems="start" spacing={0}>
          <HighlightOrDisplay field="process" result={orderItemResult} />
          <HighlightOrDisplay field="material" result={orderItemResult} />
          <HighlightOrDisplay field="finishes" result={orderItemResult} />
          <ValueText useDataFont>
            {orderItemResult.data.price ? orderItemResult.data.price : '--'}
          </ValueText>
          <ValueText useDataFont>
            {orderItemResult.data.unitPrice
              ? orderItemResult.data.unitPrice
              : '--'}
          </ValueText>
          <ValueText useDataFont>
            {orderItemResult.data.quantity
              ? orderItemResult.data.quantity
              : '--'}
          </ValueText>
        </VStack>
      </HStack>
    </Box>
  );
};

export default OrderItemMatchCell;
